module.exports = __webpack_public_path__ + "static/ferryTee.1ec5891a.png";